import { render, staticRenderFns } from "./updatequeue.vue?vue&type=template&id=af728286"
import script from "./updatequeue.vue?vue&type=script&lang=js"
export * from "./updatequeue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports